// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.puzzle-card {
    height:90vh ;
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
   max-width: 100%;
  overflow-y: auto;
 }

.puzzle-items {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.puzzle-item {
  padding: 10px;
  border-left: 3px solid #333;
  background: #f9f9f9;
  border-radius: 6px;
}
/* header layout */
.puzzle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.toggle-btn {
  margin-top: 8px;
  padding: 6px 10px;
  border: none;
  background: #333;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.toggle-btn:hover {
  background: #555;
}

.desc {
  margin-top: 10px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/features/Puzzles/puzzles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;GACrC,eAAe;EAChB,gBAAgB;CACjB;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".puzzle-card {\n    height:90vh ;\n  padding: 16px;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n   max-width: 100%;\n  overflow-y: auto;\n }\n\n.puzzle-items {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.puzzle-item {\n  padding: 10px;\n  border-left: 3px solid #333;\n  background: #f9f9f9;\n  border-radius: 6px;\n}\n/* header layout */\n.puzzle-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.toggle-btn {\n  margin-top: 8px;\n  padding: 6px 10px;\n  border: none;\n  background: #333;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.toggle-btn:hover {\n  background: #555;\n}\n\n.desc {\n  margin-top: 10px;\n  padding: 8px;\n  background: #f5f5f5;\n  border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
